<div fxLayout="row">
  <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayoutAlign="start center" fxLayout="row"  fxLayoutGap="1rem">
      <a *ngIf="!showLogo" (click)="redirect('/')" (keyDown)="redirect('/')">
        <neq-icon svgIcon="MatrixNutri-logo" ></neq-icon>
      </a>
      <a *ngIf="showGoBack">
        <neq-icon svgIcon="chevron-gauche" (click)="goLastPage()" (keyDown)="goLastPage()"></neq-icon>
      </a>
      <img *ngIf="showLogo" class="matrixnutri-title" src="assets/img/MatrixNutri-title.svg" alt="MatrixNutri">
      <span class="primary-big"><strong *ngIf="strongLabel" >{{strongLabel}}</strong> {{basicLabel ? basicLabel : ''}}</span>
    </div>
    <ul style="{{ importSemiautoOnGoing || multimodificationOnGoing ? 'flex-grow: 1;' : '' }}">
      <ng-container *ngIf="isFeedOperatingMode() && showResearch()">
        <li>
          <a fxLayout="row" fxLayoutAlign="center center">
            <neq-select-autocomplete [markFirst]="false" class="user-simple-search"
                                     [dataSource]="fetchBaseRawmaterial" (change)="onSelectRawmaterial($event)">
            </neq-select-autocomplete>
            <neq-icon svgIcon="recherche"></neq-icon>
          </a>
        </li>
        <li>
          <a (click)="goRmAdvancedSearch()">
            <span *ngIf="!show">{{'label.common.search.advanced' | translate}}</span>
          </a>
        </li>
      </ng-container>

      <ng-container *ngIf="!isFeedOperatingMode() && showResearch()">
        <li>
          <a fxLayout="row" fxLayoutAlign="center center">
            <neq-select-autocomplete [markFirst]="false" class="user-simple-search"
                                     [dataSource]="fetchBaseSample" (change)="onSelectSample($event)">
            </neq-select-autocomplete>
            <neq-icon svgIcon="recherche"></neq-icon>
          </a>
        </li>
        <li>
          <a (click)="goSampleAdvancedSearch()">
            <span>{{'label.common.search.advanced' | translate}}</span>
          </a>
        </li>
      </ng-container>

      <li *ngIf="showCalculateBatchJob()">
        <div>
          <a (click)="goJobDetail()">
            <span [innerHTML]="getJobStep()"></span>
          </a><br/>
          <mat-progress-bar *ngIf="showProgress()" [mode]="getProgressMode()" [value]="getProgressValue()"></mat-progress-bar>
        </div>
      </li>
      <li *ngIf="showImportFullAuto()" >
        <div>
          <a style="pointer-events: none;">
            <span> {{ 'msg.user.import-full-auto.running' | translate }}</span>
          </a><br/>
          <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
      </li>
      <li *ngIf="importSemiautoOnGoing" style="width: 100%;">
        <neq-import-semiauto></neq-import-semiauto>
      </li>
      <li *ngIf="multimodificationOnGoing" style="width: 100%;">
        <neq-rm-or-sample-multimodification></neq-rm-or-sample-multimodification>
      </li>
    </ul>
    <div fxLayoutAlign="end center">
      <div mat-button #userDropdown (click)="openDropdown = true">
        <ul class="no-border align-right" style="margin: 0;">
          <li>
            <a>
              {{user.full_name}}<br>
              <span class="society">{{userEntity.name}}</span>
            </a>
          </li>
          <li>
            <button class="neq-user-menu-button" mat-icon-button [matMenuTriggerFor]="appMenu">
              <img height="57px" width="57px" *ngIf="userEntityLogo" [src]="userEntityLogo" alt="userEntityLogo">
              <neq-icon svgIcon="chevron-bas" class="neq-chevron"></neq-icon>
            </button>
          </li>
        </ul>
      </div>
      <mat-menu #appMenu="matMenu">
        <button mat-menu-item
                (click)="redirect('app/account')">
          {{ 'label.user.my-account' | translate }}</button>
        <ng-container *ngIf="isFeedOperatingMode()">
          <button mat-menu-item *hasRights="exportSettingsRight"
                  (click)="redirect('app/rawmaterials/export/settings')"
          >
            {{ 'label.user.export.settings' | translate }}
          </button>
        </ng-container>
        <button mat-menu-item *ngIf="displayChangeEntityMenu()"
                (click)="redirect('entity')" >
          {{ 'label.user.change-entity' | translate }}</button>
        <button mat-menu-item *ngIf="isAdmin()"
                (click)="redirect('admin-site')">
          {{'label.user.link.admin' | translate}}</button>
        <button mat-menu-item
                (click)="logout()">
          {{'label.common.logout' | translate}}</button>
      </mat-menu>
    </div>
  </mat-toolbar>
</div>
